import type * as Types from '../../../../generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ProviderCalendarsQueryVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type ProviderCalendarsQuery = { __typename?: 'Query', provider?: { __typename?: 'Provider', id: string, cronofyExternalCalendar?: { __typename?: 'CronofyCalendar', id: string, calendarId?: string | null, sub?: string | null, scope: string, elementToken: string } | null, cronofyInternalCalendar?: { __typename?: 'CronofyCalendar', id: string, sub?: string | null, scope: string, elementToken: string } | null } | null };

export type BlockTimeSlotMutationVariables = Types.Exact<{
  id: Types.Scalars['ID'];
  startTime: Types.Scalars['ISO8601DateTime'];
  endTime: Types.Scalars['ISO8601DateTime'];
}>;


export type BlockTimeSlotMutation = { __typename?: 'Mutation', blockTimeSlot?: { __typename?: 'BlockTimeSlotPayload', cronofyInternalCalendar: { __typename?: 'CronofyCalendar', id: string, sub?: string | null, scope: string, elementToken: string } } | null };


export const ProviderCalendarsDocument = gql`
    query ProviderCalendars($id: ID!) {
  provider(id: $id) {
    id
    cronofyExternalCalendar {
      id
      calendarId
      sub
      scope
      elementToken
    }
    cronofyInternalCalendar {
      id
      sub
      scope
      elementToken
    }
  }
}
    `;

/**
 * __useProviderCalendarsQuery__
 *
 * To run a query within a React component, call `useProviderCalendarsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProviderCalendarsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProviderCalendarsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProviderCalendarsQuery(baseOptions: Apollo.QueryHookOptions<ProviderCalendarsQuery, ProviderCalendarsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProviderCalendarsQuery, ProviderCalendarsQueryVariables>(ProviderCalendarsDocument, options);
      }
export function useProviderCalendarsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProviderCalendarsQuery, ProviderCalendarsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProviderCalendarsQuery, ProviderCalendarsQueryVariables>(ProviderCalendarsDocument, options);
        }
export type ProviderCalendarsQueryHookResult = ReturnType<typeof useProviderCalendarsQuery>;
export type ProviderCalendarsLazyQueryHookResult = ReturnType<typeof useProviderCalendarsLazyQuery>;
export type ProviderCalendarsQueryResult = Apollo.QueryResult<ProviderCalendarsQuery, ProviderCalendarsQueryVariables>;
export const BlockTimeSlotDocument = gql`
    mutation BlockTimeSlot($id: ID!, $startTime: ISO8601DateTime!, $endTime: ISO8601DateTime!) {
  blockTimeSlot(
    input: {internalCalendarId: $id, startTime: $startTime, endTime: $endTime}
  ) {
    cronofyInternalCalendar {
      id
      sub
      scope
      elementToken
    }
  }
}
    `;
export type BlockTimeSlotMutationFn = Apollo.MutationFunction<BlockTimeSlotMutation, BlockTimeSlotMutationVariables>;

/**
 * __useBlockTimeSlotMutation__
 *
 * To run a mutation, you first call `useBlockTimeSlotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBlockTimeSlotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [blockTimeSlotMutation, { data, loading, error }] = useBlockTimeSlotMutation({
 *   variables: {
 *      id: // value for 'id'
 *      startTime: // value for 'startTime'
 *      endTime: // value for 'endTime'
 *   },
 * });
 */
export function useBlockTimeSlotMutation(baseOptions?: Apollo.MutationHookOptions<BlockTimeSlotMutation, BlockTimeSlotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BlockTimeSlotMutation, BlockTimeSlotMutationVariables>(BlockTimeSlotDocument, options);
      }
export type BlockTimeSlotMutationHookResult = ReturnType<typeof useBlockTimeSlotMutation>;
export type BlockTimeSlotMutationResult = Apollo.MutationResult<BlockTimeSlotMutation>;
export type BlockTimeSlotMutationOptions = Apollo.BaseMutationOptions<BlockTimeSlotMutation, BlockTimeSlotMutationVariables>;